import { render } from "./priceChartBox.vue?vue&type=template&id=399f0362"
import script from "./priceChartBox.vue?vue&type=script&lang=js"
export * from "./priceChartBox.vue?vue&type=script&lang=js"
script.render = render

export default script